/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from "react";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next"
import axios from "axios";

import { set } from "js-cookie";
import {
  WhiteSource,
  RedSource,
  GreenSource,
  Plus,
  Minus,
  X,
} from "../../Constants/assets";
import ResourcesExchangeItem from "./ResourcesExchangeItem";
import { ResourcesExchangeItems } from "../../data/ResourcesExchangeItems";

// Stylings
const InnerContainer = styled.div`
  position: absolute;
  z-index: 105;
  width: 500px;
  height: max-content;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;
const ExchangeModal = styled.div`
  position: absolute;
  width: 500px;
  height: max-content;
  z-index: 105;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  padding: 0px 2px 0px 2px;
`;
const TextContainer = styled.div`
  margin: 5% 0 0 5%;
  height: max-content;
  margin-bottom: 10px;
  @-moz-document url-prefix() {
    & {
      margin-left: 3.125rem;
    }
  }
  ${"" /* display: flex; */}
  ${"" /* flex-direction: column;
    justifyContent: flex-start; */
  }
`;

const TextContainerExchange = styled.div`
  margin: 5% 0 0 5%;
  height: max-content;
  @-moz-document url-prefix() {
    & {
      margin-left: 3.125rem;
    }
  }
  /* Media query for screens with a height less than 730px */
  ${css`
    @media (max-height: 730px) {
      /* CSS styles for screens with a height less than 730px */
      height:180px
      /* Add other styles as needed */
    }
  `}
`;
const Header = styled.h1`
  font-weight: bold;
  font-size: 24px;
  display: flex;
  justify-content: space-between;
  width: 95%;
  line-height: 150%;
`;
const MiddleContainer = styled.div`
  display: flex;
  width: 100%;
  height: 330px;
  align-items: flex-start;
  justify-content: center;
`;
const LeftSide = styled.div`
  width: 87%;
  height: 100%;
`;
const LineLeft = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  height: 33.333%;
`;
const Amount = styled.div`
  font-size: 16px;
  line-height: 19px;
  width: 20%;
  place-self: center;
  height: 80%;
`;
const MinusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  margin-left: 7px;
  opacity: 0.9;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  :active {
    transform: translateY(1px);
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  }
`;
const NumberContainer = styled.div`
  width: 12%;
  text-align: center;
  line-height: 220%;
  font-size: 19px;
  font-weight: bold;
`;
const SumContainer = styled.div``;
const SumBox = styled.div`
  background: ${(props) => props.theme.colors.lighterDarkGreen};
  border-radius: 4px;
  width: 80px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const SumText = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 22px;
  text-align: center;
  color: ${(props) => props.theme.colors.darkGreen};
  height: 50%;
  align-self: center;
`;

const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 80px;
`;
const BuyButtonContainer = styled.div`
  border-radius: 4px;
  width: 216px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const BuyText = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1rem;
  text-align: center;
  color: ${(props) => props.theme.colors.white};
`;
const BodyContainer = styled.div`
  height: 500px;
    /* Media query for screens with a height less than 730px */
    ${css`
    @media (max-height: 730px) {
      height: 51%;
    }
  `}
  margin: auto 2rem; 
  @-moz-document url-prefix(){
    &{
      margin: auto 2rem; 
    }
  text-align: -webkit-center;
`;
const FotterContainer = styled.div`
  height: 150px;
  width: 95%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;
const ExchangeButtonContainer = styled.div``;
const ExchangeButton = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.darkGreen};
  border-radius: 4px;
  width: 13.5rem;
  height: 3.125rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  :active {
    background: ${(props) => props.theme.colors.lightGray};
  }
`;
const Description = styled.div`
  width: 25%;
  align-self: center;
  height: 90%;
  font-size: 19px;
`;

// switch
const SwitchContainer = styled.div`
  display: flex;
  border: 1px solid ${(props) => props.theme.colors.darkGreen};
  box-sizing: border-box;
  border-radius: 4px;
  width: 93%;
  height: 30px;
  margin-top: 2%;
`;
const SwitchLeftOption = styled.div`
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  align-self: center;
  ${(props) =>
    props.stage == 0
      ? css`
          background: ${(componentProps) =>
          componentProps.theme.colors.darkGreen};
          color: ${(componentProps) => componentProps.theme.colors.white};
        `
      : css`
          background: ${(componentProps) => componentProps.theme.colors.white};
          color: ${(componentProps) => componentProps.theme.colors.darkGreen};
          cursor: pointer;
        `};
`;
const SwitchRightOption = styled.div`
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  align-self: center;
  color: ${(props) => props.theme.colors.darkGreen};
  ${(props) =>
    props.stage == 1
      ? css`
          background: ${(componentProps) =>
          componentProps.theme.colors.darkGreen};
          color: ${(componentProps) => componentProps.theme.colors.white};
        `
      : css`
          background: ${(componentProps) => componentProps.theme.colors.white};
          color: ${(componentProps) => componentProps.theme.colors.darkGreen};
          cursor: pointer;
        `};
`;
const ParagraphContainer = styled.div`
  display: flex;
  width: 93%;
  justify-content: center;
`;
const Paragraph = styled.div`
  margin: 4% auto;
`;
const ErrorMessageContainer = styled.div`
  width: 38%;
  font-size: 14px;
`;
const CenterContainer = styled.div`
  width: 100%;
  height: 30%;
  display: flex;
  justify-content: space-between;
`;
const ExchangeContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5%;
  height: 40%;
  align-items: center;
`;
const PlusContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  opacity: 0.9;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.3);
  border-radius: 4px;
  :active {
    transform: translateY(1px);
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.3);
  }
`;
const SideContainer = styled.div`
  width: 50%;
  height: 100%;
`;
const Price = styled.div`
  font-size: 16px;
  line-height: 19px;
  width: 26%;
  text-align: center;
`;
const Br = styled.div``;
const Line = styled.div`
  border-bottom: 1px solid ${(props) => props.theme.colors.lightGray};
  width: 100%;
  height: 2%;
`;

const BiggerWhiteSource = styled(WhiteSource)`
  width: 22px;
  height: 22px;
`;
const BiggerRedSource = styled(RedSource)`
  width: 22px;
  height: 22px;
`;
const BiggerGreenSource = styled(GreenSource)`
  width: 22px;
  height: 22px;
`;

export default function ResourcesPopUp({
  // prices,
  // pricesExchange,
  resourcesShow,
  toggleResources,
  resources,
  exchangeResources,
  exchangeResourcesTest,
  data,
  showIsPaused,
  setResourcesInTheTurn,
  amountResourcesExpensive,
  commentResourcesAtDoublePrice,
  moneySound,
  SoundPlay,
}) {
  const [white, setWhite] = useState(0);
  const [red, setRed] = useState(0);
  const [green, setGreen] = useState(0);
  const [whiteOne, setWhiteOne] = useState(0);
  const [redOne, setRedOne] = useState(0);
  const [greenOne, setGreenOne] = useState(0);
  const [whiteTwo, setWhiteTwo] = useState(0);
  const [redTwo, setRedTwo] = useState(0);
  const [greenTwo, setGreenTwo] = useState(0);
  const [whiteThree, setWhiteThree] = useState(0);
  const [redThree, setRedThree] = useState(0);
  const [greenThree, setGreenThree] = useState(0);
  const [maxOne, setMaxOne] = useState(0);
  const [maxTwo, setMaxTwo] = useState(0);
  const [maxThree, setMaxThree] = useState(0);
  const prices = {};
  const pricesExchange = {};

  const { t } = useTranslation();
  if (showIsPaused) {
    Object.assign(prices, { white: 100, red: 200, green: 500 });
    Object.assign(pricesExchange, { white: 100, red: 200, green: 500 });
  } else {
    Object.assign(prices, { white: 200, red: 400, green: 1000 });
    Object.assign(pricesExchange, { white: 100, red: 200, green: 500 });
  }

  const redValueOne = redOne * pricesExchange.red;
  const redValueTwo = redTwo * prices.red;
  const redValueThree = redThree * pricesExchange.red;

  const greenValueOne = greenOne * pricesExchange.green;
  const greenValueTwo = greenTwo * pricesExchange.green;
  const greenValueThree = greenThree * prices.green;

  const whiteValueOne = whiteOne * prices.white;
  const whiteValueTwo = whiteTwo * pricesExchange.white;
  const whiteValueThree = whiteThree * pricesExchange.white;

  const totalWhite = whiteTwo + whiteThree - whiteOne;
  const totalRed = redOne + redThree - redTwo;
  const totalGreen = greenOne + greenTwo - greenThree;
  const valueInsterted = whiteValueOne + redValueTwo + greenValueThree;
  const valueTaked =
    whiteValueTwo +
    whiteValueThree +
    redValueOne +
    redValueThree +
    greenValueOne +
    greenValueTwo;
  const valueDif = valueInsterted - valueTaked;

  const decrement = (resource) => {
    if (resource === "white" && white > 0)
      setWhite((currentResource) => currentResource - 1);
    else if (resource === "red" && red > 0)
      setRed((currentResource) => currentResource - 1);
    else if (resource === "green" && green > 0)
      setGreen((currentResource) => currentResource - 1);
    else if (resource === "whiteTwo" && whiteTwo > 0)
      setWhiteTwo((currentResource) => currentResource - 1);
    else if (resource === "redTwo" && redTwo > 0)
      setRedTwo((currentResource) => currentResource - 1);
    else if (resource === "greenTwo" && greenTwo > 0)
      setGreenTwo((currentResource) => currentResource - 1);
    else if (resource === "redThree" && redThree > 0)
      setRedThree((currentResource) => currentResource - 1);
    else if (resource === "whiteThree" && whiteThree > 0)
      setWhiteThree((currentResource) => currentResource - 1);
    else if (resource === "greenThree" && greenThree > 0)
      setGreenThree((currentResource) => currentResource - 1);
    else if (resource === "redOne" && redOne > 0)
      setRedOne((currentResource) => currentResource - 1);
    else if (resource === "whiteOne" && whiteOne > 0)
      setWhiteOne((currentResource) => currentResource - 1);
    else if (resource === "greenOne" && greenOne > 0)
      setGreenOne((currentResource) => currentResource - 1);
  };

  const increment = (resource) => {
    if (resource === "white")
      setWhite((currentResource) => currentResource + 1);
    else if (resource === "red")
      setRed((currentResource) => currentResource + 1);
    else if (resource === "green")
      setGreen((currentResource) => currentResource + 1);
    else if (resource === "whiteTwo" && resources.regular > totalWhite)
      setWhiteTwo((currentResource) => currentResource + 1);
    else if (resource === "redTwo")
      setRedTwo((currentResource) => currentResource + 1);
    else if (resource === "greenTwo" && resources.expensive > totalGreen)
      setGreenTwo((currentResource) => currentResource + 1);
    else if (resource === "redThree" && resources.executive > totalRed)
      setRedThree((currentResource) => currentResource + 1);
    else if (resource === "whiteThree" && resources.regular > totalWhite)
      setWhiteThree((currentResource) => currentResource + 1);
    else if (resource === "greenThree")
      setGreenThree((currentResource) => currentResource + 1);
    else if (resource === "redOne" && resources.executive > totalRed)
      setRedOne((currentResource) => currentResource + 1);
    else if (resource === "whiteOne")
      setWhiteOne((currentResource) => currentResource + 1);
    else if (resource === "greenOne" && resources.expensive > totalGreen)
      setGreenOne((currentResource) => currentResource + 1);
  };

  const [stage, setStage] = useState(0);
  const sum = prices.green * green + prices.red * red + prices.white * white;
  const currentBudget = data?.budget || 0;
  if (!resourcesShow) return null;

  if (stage == 0) {
    return (
      <InnerContainer>
        <TextContainer>
          <Header>
            {t('modals.buy_resources.info_title')}
            <X
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggleResources(false);
                setWhite(0);
                setRed(0);
                setGreen(0);
              }}
            />
          </Header>
          <ParagraphContainer>
            <Paragraph>
              {t('modals.buy_resources.info_text')}
            </Paragraph>
          </ParagraphContainer>
          <SwitchContainer>
            <SwitchLeftOption stage={stage} onClick={() => setStage(0)}>
              {" "}
              {t('modals.buy_resources.button1')}
            </SwitchLeftOption>
            <SwitchRightOption
              stage={stage}
              onClick={() => {
                setStage(1);
                setWhite(0);
                setRed(0);
                setGreen(0);
              }}
            >
              {t('modals.buy_resources.button2')}
            </SwitchRightOption>
          </SwitchContainer>
        </TextContainer>
        <MiddleContainer>
          <LeftSide>
            <LineLeft>
              <Description style={{ color: "#81818C" }}>{t('global_variables.resources.standard')}</Description>
              <BiggerWhiteSource
                style={{ width: "17%", height: "21.6px", marginTop: "1.5%" }}
              />
              <Amount>${prices.white}</Amount>
              <MinusContainer
                style={{ cursor: "pointer", marginRight: "-2px" }}
                onClick={() => decrement("white")}
              >
                <Minus style={{ width: "36px" }} />
              </MinusContainer>
              <NumberContainer style={{ marginRight: "-7px" }}>
                {white}
              </NumberContainer>
              <MinusContainer
                style={{ cursor: "pointer", marginRight: "30px" }}
                onClick={() => increment("white")}
              >
                <Plus style={{ width: "36px" }} />
              </MinusContainer>
              <SumContainer>
                <SumBox>
                  <SumText> ${prices.white * white}</SumText>
                </SumBox>
              </SumContainer>
            </LineLeft>
            <LineLeft>
              <Description style={{ color: "#DF6397" }}>{t('global_variables.resources.senior')}</Description>
              <BiggerRedSource
                style={{ width: "17%", height: "21.6px", marginTop: "1.5%" }}
              />
              <Amount>${prices.red}</Amount>
              <MinusContainer
                style={{ cursor: "pointer", width: "36px", height: "36px" }}
                onClick={() => decrement("red")}
              >
                <Minus style={{ width: "36px" }} />
              </MinusContainer>
              <NumberContainer style={{ marginRight: "-7px" }}>
                {red}
              </NumberContainer>
              <MinusContainer
                style={{ cursor: "pointer", marginRight: "30px" }}
                onClick={() => increment("red")}
              >
                <Plus style={{ width: "36px" }} />
              </MinusContainer>
              <SumContainer>
                <SumBox>
                  <SumText> ${prices.red * red}</SumText>
                </SumBox>
              </SumContainer>
            </LineLeft>
            <LineLeft>
              <Description style={{ color: "#007A9E" }}>{t('global_variables.resources.executive')}</Description>
              <BiggerGreenSource
                style={{ width: "17%", height: "21.6px", marginTop: "1.5%" }}
              />
              <Amount>${prices.green}</Amount>
              <MinusContainer
                style={{ cursor: "pointer" }}
                onClick={() => decrement("green")}
              >
                <Minus style={{ width: "36px" }} />
              </MinusContainer>
              <NumberContainer style={{ marginRight: "-7px" }}>
                {green}
              </NumberContainer>
              <MinusContainer
                style={{ cursor: "pointer", marginRight: "30px" }}
                onClick={() => increment("green")}
              >
                <Plus style={{ width: "36px" }} />
              </MinusContainer>
              <SumContainer>
                <SumBox>
                  <SumText> ${prices.green * green}</SumText>
                </SumBox>
              </SumContainer>
            </LineLeft>
          </LeftSide>
        </MiddleContainer>
        {sum <= currentBudget && sum != 0 && (
          <BottomContainer style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                width: "56%",
              }}
            >
              <BuyButtonContainer
                style={{
                  cursor: "pointer",
                  background: "#2b2b32",
                }}
                onClick={() => {
                  const resourceObject = {
                    regular: white,
                    senior: red,
                    executive: green,
                  };
                  exchangeResources(
                    (resources.regular === undefined ? 0 : resources.regular) +
                    white,
                    (resources.executive === undefined
                      ? 0
                      : resources.executive) + red,
                    (resources.expensive === undefined
                      ? 0
                      : resources.expensive) + green,
                    true,
                    resourceObject
                  );
                  toggleResources(false);
                  setWhite(0);
                  setRed(0);
                  setGreen(0);
                  SoundPlay(moneySound);
                  if (!showIsPaused) {
                    setResourcesInTheTurn([
                      amountResourcesExpensive[0] + white,
                      amountResourcesExpensive[1] + red,
                      amountResourcesExpensive[2] + green,
                    ]);
                    // commentResourcesAtDoublePrice();
                  }
                }}
              >
                <BuyText> {t('modals.buy_resources.button3')} ${sum}</BuyText>
              </BuyButtonContainer>
            </div>
          </BottomContainer>
        )}
        {(sum > currentBudget || sum == 0) && (
          <BottomContainer style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-evenly",
                width: "100%",
              }}
            >
              {" "}
              {sum > 0 && <ErrorMessageContainer />}
              {sum == 0 && (
                <ErrorMessageContainer>
                  {t('modals.buy_resources.choose_resources')}
                </ErrorMessageContainer>
              )}
              <BuyButtonContainer
                style={{
                  background: "#81818c",
                }}
              >
                <BuyText> {t('modals.buy_resources.button3')} ${sum}</BuyText>
              </BuyButtonContainer>
            </div>
          </BottomContainer>
        )}
      </InnerContainer>
    );
  }
  if (stage == 1) {
    return (
      <ExchangeModal>
        <TextContainerExchange>
          <Header>
            {t('modals.buy_resources.exchange.exchange')}
            <X
              style={{ cursor: "pointer" }}
              onClick={() => {
                toggleResources(false);
                setWhiteOne(0);
                setRedOne(0);
                setGreenOne(0);
                setWhiteTwo(0);
                setWhiteThree(0);
                setGreenTwo(0);
                setGreenThree(0);
                setRedTwo(0);
                setRedThree(0);
                setStage(0);
              }}
            />
          </Header>
          <ParagraphContainer>
            <Paragraph>
              {t('modals.buy_resources.exchange.info_text')}
            </Paragraph>
          </ParagraphContainer>
          <SwitchContainer style={{ marginTop: "-5px" }}>
            <SwitchLeftOption
              stage={stage}
              onClick={() => {
                setStage(0);
                setWhiteOne(0);
                setRedOne(0);
                setGreenOne(0);
                setWhiteTwo(0);
                setWhiteThree(0);
                setGreenTwo(0);
                setGreenThree(0);
                setRedTwo(0);
                setRedThree(0);
              }}
            >
              {" "}
              {t('modals.buy_resources.button1')}
            </SwitchLeftOption>
            <SwitchRightOption stage={stage} onClick={() => setStage(1)}>
              {t('modals.buy_resources.button2')}
            </SwitchRightOption>
          </SwitchContainer>
        </TextContainerExchange>
        <BodyContainer>
          {/* {ResourcesExchangeItems.map((current, index, array) => {
                        const isLast = index === array.length - 1;
                        return (
                            <>
                                <ResourcesExchangeItem
                                    {...current}
                                    key={index}
                                    white={white}
                                    red={red}
                                    green={green}
                                    resource={resources}
                                />
                                {!isLast && (
                                    <hr
                                        style={{
                                            width: '88%',
                                            border: '1px solid {props => props.theme.colors.gray}',
                                        }}
                                    />
                                )}
                            </>
                        );
                    })} */}
          <CenterContainer>
            <SideContainer style={{ width: "40%" }}>
              <ExchangeContainer>
                <BiggerWhiteSource />
                <Price>${whiteValueOne}</Price>
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (
                      whiteValueOne - prices.white >=
                      redValueOne + greenValueOne
                    ) {
                      decrement("whiteOne");
                    }
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {whiteOne}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    // if ( // Latest request to be able to increment the "Right" side without having to increment the "Left" side.
                    //   whiteValueOne + pricesExchange.white <=
                    //   greenValueOne + redValueOne
                    // ) {
                    increment("whiteOne");
                    // }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
            </SideContainer>
            <SideContainer style={{ width: "60%" }}>
              <ExchangeContainer>
                <Price style={{ fontSize: "0.75rem" }}> {t('modals.buy_resources.exchange.exchange')} </Price>
                <BiggerRedSource />
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    decrement("redOne");
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {redOne}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (redOne < resources.executive) {
                      increment("redOne");
                    }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
              <ExchangeContainer>
                <Price style={{ fontSize: "0.75rem" }} />
                <BiggerGreenSource />
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    decrement("greenOne");
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {greenOne}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (greenOne < resources.expensive) {
                      increment("greenOne");
                    }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
            </SideContainer>
          </CenterContainer>
          <Line />
          <Br style={{ height: "3%" }} />
          <CenterContainer>
            <SideContainer style={{ width: "40%" }}>
              <ExchangeContainer>
                <BiggerRedSource />
                <Price>${redValueTwo}</Price>
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (
                      redValueTwo - prices.red >=
                      greenValueTwo + whiteValueTwo
                    ) {
                      decrement("redTwo");
                    }
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {redTwo}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    // if ( // Latest request to be able to increment the "Right" side without having to increment the "Left" side.
                    //   redValueTwo + pricesExchange.white <=
                    //   greenValueTwo + whiteValueTwo
                    // ) {
                    increment("redTwo");
                    // }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
            </SideContainer>
            <SideContainer style={{ width: "60%" }}>
              <ExchangeContainer>
                <Price style={{ fontSize: "0.75rem" }}>{t('modals.buy_resources.exchange.exchange')}</Price>
                <BiggerWhiteSource />
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    decrement("whiteTwo");
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {whiteTwo}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (whiteTwo < resources.regular) {
                      increment("whiteTwo");
                    }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
              <ExchangeContainer>
                <Price style={{ fontSize: "0.75rem" }} />
                <BiggerGreenSource />
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    decrement("greenTwo");
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {greenTwo}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (greenTwo < resources.expensive) {
                      increment("greenTwo");
                    }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
            </SideContainer>
          </CenterContainer>
          <Line />
          <Br style={{ height: "3%" }} />
          <CenterContainer>
            <SideContainer style={{ width: "40%" }}>
              <ExchangeContainer>
                <BiggerGreenSource />
                <Price>${greenValueThree}</Price>
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (
                      greenValueThree - prices.green >=
                      redValueThree + whiteValueThree
                    ) {
                      decrement("greenThree");
                    }
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {greenThree}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    // if ( // Latest request to be able to increment the "Right" side without having to increment the "Left" side.
                    //   greenValueThree + pricesExchange.white <=
                    //   redValueThree + whiteValueThree
                    // ) {
                    increment("greenThree");
                    // }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
            </SideContainer>
            <SideContainer style={{ width: "60%" }}>
              <ExchangeContainer>
                <Price style={{ fontSize: "0.75rem" }}>{t('modals.buy_resources.exchange.exchange')}</Price>
                <BiggerWhiteSource />
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    decrement("whiteThree");
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {whiteThree}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (whiteThree < resources.regular) {
                      increment("whiteThree");
                    }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
              <ExchangeContainer>
                <Price style={{ fontSize: "0.75rem" }} />
                <BiggerRedSource />
                <MinusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    decrement("redThree");
                  }}
                >
                  <Minus />
                </MinusContainer>
                <NumberContainer style={{ width: "17%" }}>
                  {redThree}
                </NumberContainer>
                <PlusContainer
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (redThree < resources.executive) {
                      increment("redThree");
                    }
                  }}
                >
                  <Plus />
                </PlusContainer>
              </ExchangeContainer>
            </SideContainer>
          </CenterContainer>
        </BodyContainer>
        <FotterContainer>
          <ExchangeButtonContainer>
            {valueDif == 0 && valueInsterted != 0 && (
              <ExchangeButton
                onClick={() => {
                  const regular =
                    (resources.regular === undefined ? 0 : resources.regular) -
                    totalWhite;
                  const senior =
                    (resources.executive === undefined
                      ? 0
                      : resources.executive) - totalRed;
                  const executive =
                    (resources.expensive === undefined
                      ? 0
                      : resources.expensive) - totalGreen;
                  const resourceObject = {
                    regular: -totalWhite,
                    senior: -totalRed,
                    executive: -totalGreen,
                  };
                  exchangeResources(
                    regular,
                    senior,
                    executive,
                    false,
                    resourceObject
                  );
                  toggleResources(false);
                  setWhiteOne(0);
                  setRedOne(0);
                  setGreenOne(0);
                  setWhiteTwo(0);
                  setWhiteThree(0);
                  setGreenTwo(0);
                  setGreenThree(0);
                  setRedTwo(0);
                  setRedThree(0);
                  SoundPlay(moneySound);
                  setStage(0);
                }}
              >
                {t("modals.buy_resources.exchange.button1")}
              </ExchangeButton>
            )}
            {(valueDif != 0 || valueInsterted == 0) && (
              <ExchangeButton
                style={{ opacity: "0.5", cursor: "context-menu" }}
              >
                {t("modals.buy_resources.exchange.button1")}
              </ExchangeButton>
            )}
          </ExchangeButtonContainer>
        </FotterContainer>
      </ExchangeModal>
    );
  }
}
